import * as services from '@/services'

export default {
  namespaced: true,

  state: {
    ui: {
      authModal: { isVisible: false },
      tariffsModal: { isVisible: false },
      paywallModal: { isVisible: false },
      newPaywallModal: { isVisible: false },
      demoTopicModal: { isVisible: false, sectionSlug: null, topicSlug: null },

      confetti: { isVisible: false },

      happyUsers: { count: 0 }
    }
  },

  actions: {
    async FETCH_HAPPY_USERS({ state, commit }) {
      if (state.ui.happyUsers.count > 0) return state.ui.happyUsers.count

      const { content } = await services.users.fetchHappyUsers()

      commit('SET_UI_HAPPY_USERS_COUNT', content.count)

      return content.count
    }
  },

  mutations: {
    SET_UI_AUTH_MODAL(
      state,
      { isVisible, componentCode = 'login', redirectTo = null, onSuccess }
    ) {
      state.ui.authModal = { isVisible, componentCode, redirectTo, onSuccess }
    },

    SET_UI_TARIFFS_MODAL_IS_VISIBLE(state, isVisible) {
      state.ui.tariffsModal.isVisible = isVisible
    },

    SET_UI_PAYWALL_MODAL_IS_VISIBLE(state, isVisible) {
      state.ui.paywallModal.isVisible = isVisible
    },

    SET_UI_NEW_PAYWALL_MODAL_IS_VISIBLE(state, isVisible) {
      state.ui.newPaywallModal.isVisible = isVisible
    },

    SET_UI_DEMO_TOPIC_MODAL(state, { isVisible, sectionSlug, topicSlug }) {
      state.ui.demoTopicModal.isVisible = isVisible
      state.ui.demoTopicModal.sectionSlug = sectionSlug
      state.ui.demoTopicModal.topicSlug = topicSlug
    },

    SET_UI_CONFETTI(state, options) {
      state.ui.confetti = options
    },

    SET_UI_HAPPY_USERS_COUNT(state, count) {
      state.ui.happyUsers.count = count
    },

    SET_UI_HAPPY_USERS_IS_LOADING(state, isLoading) {
      state.ui.happyUsers.isLoading = isLoading
    }
  }
}
